export const MAX_PSEUDO_PROGRESS = 97;

export const UPLOAD_WAITING_PROGRESS = 0;
export const PENDING_PROGRESS = 1;
